@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading [attr.type]="attributes.type === 'standard' ? null : attributes.type" [class.align--right]="attributes.align === 'right'" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
